import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  padding: 10px;
  overflow: hidden;
`;
